import { useContext } from 'react';
import FileVersionsContext from '~src/contexts/FileVersionsContext';

export const useSortByRevision = () => {
  const { fileVersionsContext } = useContext(FileVersionsContext);

  const sortByRevision = (a, b) => {
    if (a?.dbFile && b?.dbFile) {
      if (a.dbFile?.versions && b.dbFile?.versions) {
        const selectedIndexA = fileVersionsContext[a.dbFile.versions.id]
          ? a.dbFile.versions.id.findIndex(
              (opt) => opt.id === fileVersionsContext[a.dbFile.versions.id]?.id
            )
          : 0;
        const selectedIndexB = fileVersionsContext[b.dbFile.versions.id]
          ? b.dbFile.versions.id.findIndex(
              (opt) => opt.id === fileVersionsContext[b.dbFile.versions.id]?.id
            )
          : 0;
        if (
          a.dbFile.versions[selectedIndexA].version.toLowerCase() <
          b.dbFile.versions[selectedIndexB].version.toLowerCase()
        ) {
          return -1;
        }
        if (
          a.dbFile.versions[selectedIndexA].version.toLowerCase() >
          b.dbFile.versions[selectedIndexB].version.toLowerCase()
        ) {
          return 1;
        }
      }
    }
    return 0;
  };

  const sortByLoacion = (a, b) => {
    if (a?.location && b.location) {
      if (a.location.toLowerCase() < b.location.toLowerCase()) {
        return -1;
      }
      if (a.location.toLowerCase() > b.location.toLowerCase()) {
        return 1;
      }
    }
    return 0;
  };

  return { sortByRevision, sortByLoacion };
};
